import { render, staticRenderFns } from "./TotalStockValue.vue?vue&type=template&id=24b04594&scoped=true&"
import script from "./TotalStockValue.vue?vue&type=script&lang=js&"
export * from "./TotalStockValue.vue?vue&type=script&lang=js&"
import style0 from "./TotalStockValue.vue?vue&type=style&index=0&id=24b04594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b04594",
  null
  
)

export default component.exports